import { createContext } from 'react';
export const ScrollContainerContext = createContext(undefined);
